/* eslint-disable no-undef */
/* eslint-disable max-len */

export const API_AUTH = 'https://sc.smartkulsary.kz/api/auth';
export const API_ROOT = 'https://sc.smartkulsary.kz/api/scadmin';
